import axios from 'axios'

type CookieData = {
  name: string
  value: string
  maxAge: string
}

function getCookie(name: string) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)

  return parts.length === 2 ? parts?.pop()?.split(';').shift() : null
}

function setCookie(name: string, value: string, maxAgeSeconds: number) {
  document.cookie = `${name}=${value}; path=/; max-age=${maxAgeSeconds}; SameSite=Lax; Secure; domain=decathlon.com.br`
}

export async function ensureDYCookies() {
  const dyid = getCookie('_dyid')
  const sessionId = getCookie('_dyjsession')

  if (dyid && sessionId) {
    return { dyid, dyidServer: dyid, sessionId }
  }

  try {
    const { data: cookies } = await axios.get<CookieData[]>(
      '/api/getDynamicYieldCookies'
    )

    const fetchedCookies = {
      dyid: dyid ?? '',
      dyidServer: dyid ?? '',
      sessionId: sessionId ?? '',
    }

    cookies.flat().forEach(({ value, maxAge, name }) => {
      if (name === '_dyid_server' && !dyid) {
        setCookie('_dyid', value, Number(maxAge))
        setCookie('_dyid_server', value, Number(maxAge))
        fetchedCookies.dyid = value
        fetchedCookies.dyidServer = value
      }

      if (name === '_dyjsession' && !sessionId) {
        setCookie('_dyjsession', value, Number(maxAge))
        fetchedCookies.sessionId = value
      }
    })

    return fetchedCookies
  } catch (error) {
    console.error(error)

    return {
      dyid: '',
      dyidServer: '',
      sessionId: '',
    }
  }
}
